export default __webpack_public_path__ + "static/media/service (3).53ee0488.jpg";